import ConnectedIntlProvider from './ConnectedIntlProvider';

export default ConnectedIntlProvider;
